module.exports = __webpack_public_path__ + "img/company-consent-banner-desktop.d685aa2f.svg";